import { render, staticRenderFns } from "./product-price.vue?vue&type=template&id=664bd8bd&"
import script from "./product-price.vue?vue&type=script&lang=js&"
export * from "./product-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports